module.exports = __webpack_public_path__ + "img/2.ef6649fc.svg";